export default function PHP_Destructor() {
  return (
    <div>
      <h1>PHP_Destructor</h1>
    </div>
  );
}
